import React from "react";
import { popupMenuOptions } from "../../../parent/data/popupMenuOptions";

export const TravelExemptionPopupButton = ({
  callGetTravelExemptionEligibility,
  AgreeNbr,
  selectCardOption,
  setCardInfo
}) => {
  const onClick = () => {
    window.scrollTo(0, 0);

    callGetTravelExemptionEligibility(AgreeNbr, eligibilityCallback);
  };

  // Callback to be called on completion of the eligibility check
  const eligibilityCallback = (eligibilityResponse) => {
    window.scrollTo(0, 0);

    const isEligible = eligibilityResponse.IsEligible;
    const currentExemptionEndDate = eligibilityResponse.CurrentExemptionEndDate;
    const hasExistingExemption = currentExemptionEndDate ? true : false;

    if (isEligible) {
      setCardInfo((state) => {
        return {
          ...state,
          agreeNbr: AgreeNbr,
          type: popupMenuOptions.other.EligibleTravelExemption,
        };
      });
    } else if (hasExistingExemption) {
      selectCardOption(popupMenuOptions.invalid.ExistingTravelExemption);
    } else {
      selectCardOption(popupMenuOptions.invalid.IneligibleTravelExemption);
    }
  };

  return (
    <li>
      <button
        className="f12 mt-0 auth-card-popup-button"
        onClick={onClick}
        data-e2e-id={"travelExemptionButton"}
      >
        Request a Travel Exemption
      </button>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/card/menu/popup-menu-buttons/travel-exemption-popup-button.component.js